module.exports = __webpack_public_path__ + "img/Question-bg-2.6ba7bacf.png";